{
  "title": "Invoices",
  "subtitle": "Issued from the booking and sent via StreamPay",
  "connection": {
    "failed": "Can't connect to StreamPay",
    "connected": "StreamPay connected",
    "connectedWithReconcile": "StreamPay connected · Last reconciled {{at}}"
  },
  "toast": {
    "resendCopied": "Payment link copied to share with the customer",
    "cancelled": "Invoice cancelled",
    "retried": "Retried",
    "linkCopied": "Payment link copied"
  },
  "stats": {
    "paidThisMonth": "Paid this month",
    "awaiting": "Awaiting payment",
    "awaitingSub": "{{n}} invoices",
    "pendingSend": "Sending",
    "needsAttention": "Needs attention",
    "needsAttentionSub": "Payment or delivery failed"
  },
  "filter": {
    "label": "Filter invoices",
    "all": "All",
    "needsAttention": "Needs attention"
  },
  "search": {
    "label": "Search invoices",
    "placeholder": "Invoice no., booking ref, customer"
  },
  "table": {
    "caption": "Invoices",
    "emptyTitle": "No invoices",
    "emptyDescription": "Invoices are issued from the booking page once it's confirmed."
  },
  "columns": {
    "number": "Invoice no.",
    "booking": "Booking",
    "customer": "Customer",
    "mode": "Mode",
    "total": "Total",
    "channels": "Channels",
    "status": "Status",
    "due": "Due"
  },
  "mode": {
    "full": "Full",
    "feeOnly": "Fee only"
  },
  "menu": {
    "label": "Actions for invoice {{number}}",
    "viewBooking": "View booking",
    "copyLink": "Copy payment link",
    "resend": "Resend",
    "cancel": "Cancel invoice",
    "cancelConfirm": "Cancel invoice {{number}}? The customer will no longer be able to pay via the link."
  }
}
